import { Logo } from '@/UI/Logo';

export const SkeletonMain = () => {
  return (
    <div className="md:flex">
      <div className="navbar relative z-50 flex justify-between bg-card md:hidden">
        <Logo />
        <div className="flex-none">
          <button className="btn btn-square btn-ghost">
            <div className="swap">
              <img className="swap-off" src="/icons/burger.webp" alt="burger" />
            </div>
          </button>
        </div>
      </div>
      <aside className="hidden h-screen w-72 shrink-0 flex-col bg-card px-6 md:flex">
        <Logo className="mt-10" />
      </aside>
      <main className="h-screen w-full overflow-scroll"></main>
    </div>
  );
};
